var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68551 3.42254L2.12678 17.7325C1.57695 18.9321 2.3002 20.3999 3.4411 20.3999H16.5586C17.6995 20.3999 18.4227 18.9321 17.8729 17.7325L11.3142 3.42254C10.7443 2.17914 9.2554 2.17914 8.68551 3.42254ZM9.99982 8.09995C10.414 8.09995 10.7498 8.50289 10.7498 8.99995V13.7999C10.7498 14.297 10.414 14.6999 9.99982 14.6999C9.58561 14.6999 9.24982 14.297 9.24982 13.7999V8.99995C9.24982 8.50289 9.58561 8.09995 9.99982 8.09995ZM10.7498 16.4999C10.7498 16.997 10.414 17.3999 9.99982 17.3999C9.58561 17.3999 9.24982 16.997 9.24982 16.4999C9.24982 16.0029 9.58561 15.5999 9.99982 15.5999C10.414 15.5999 10.7498 16.0029 10.7498 16.4999Z",
    fill: "#F5C108"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b2751835.svg";
export { ForwardRef as ReactComponent };